import Vue from 'vue'
import Vuex from 'vuex'

import {
  UPDATE_LOADER,
  UPDATE_VIEW,
  UPDATE_CART_IS_ACTIVE
} from '@/store/types'

import userModule from '@/modules/User/store'
import fnolModule from '@/store/modules/fnol'
import claimModule from '@/modules/Claim/store'
import damageModule from '@/modules/Damage/store'
import flowModule from '@/modules/Flow/store'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user: userModule,
    fnol: fnolModule,
    claim: claimModule,
    damage: damageModule,
    flowModule: flowModule
  },
  state: {
    loader: false,
    agentView: true,
    cartIsActive: false,
    date: null
  },
  mutations: {
    [UPDATE_LOADER]: function (state, payload) {
      if (typeof payload === 'boolean') {
        state.loader = payload
      }
    },
    [UPDATE_VIEW]: function (state, payload) {
      if (typeof payload === 'boolean') {
        state.agentView = payload
      }
    },
    [UPDATE_CART_IS_ACTIVE]: function (state, payload) {
      if (typeof payload === 'boolean') {
        state.cartIsActive = payload
      }
    },
    setDate(state, date) {
      state.date = date
    },
    setNewDate(state, payload) {
      state.newDate = payload
    }
  },
  actions: {
    updateDate({ commit }, date) {
      commit('setDate', date)
    }
  }
})
